import React, {useState, useEffect, useRef} from 'react';
import {Container, Grid, Typography, ButtonBase} from '@material-ui/core/';
import {CheckCircleOutline} from '@material-ui/icons';
import { useStyles } from "./style";
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import Form from 'components/Form/FormTwoColumns';
import MensajeAlerta from 'components/ResponseElement'
import { useHistory } from "react-router-dom";
import ResumenSolicitudExtranjero from '../../DatosCiudadano'
import ApiServices from 'services/ApiServices';
import {showMessagePersonalizedPosition} from 'services/SweetAlert'
import ComponenteDialogoDescargarConstanciaPDF from '../GrabarSolicitudExtranjero/DescargarConstanciaPDF'
import {functions} from 'constants/index';
import ModalConfirmation from 'components/ModalConfirmation/ModalConfirmation';
import DialogLoadingMessage from 'components/LoadingMessage/index'
import allActions from 'store/actions';
import { useSelector, useDispatch } from 'react-redux'

function GrabarSolicitudExtranjero(props) {
    let history = useHistory();
    const dispatch = useDispatch();
    const classes = useStyles(),
        [loadingMessage, setLoadingMessage] = useState({loading:false, title:''}),
        [elements,setElements] = useState({
            titleObservacion:{
                idelement: "titleObservacion",title:'Observaciones', position:"center", value: "", isError:false, elementType:'title', validators: ['requireds'],
            },    
            observaciones: {
                idelement: "observaciones",  value:'', label: "Observación", pattern:"^([\\w_ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()][\\w_ -.\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()]*[\\w_.\"\'ÑñáéíóúÁÉÍÓÚäÄëËïÏöÖüÜÇç,/&()]){0,2}$", minWidth: 1100,
                validators: ['requireds'],  errorMessages:['Máximo 1024 carácteres, sin espacios al inicio y final'], isError:false, elementType:'textareaV2', showInputControl: true, maxLength: 1024
            },                        
            titlePassword:{
                idelement: "titlePassword",title:'Ingrese su contraseña de Firma Electrónica para firmar documento. ', position:"center", value: "", isError:true, elementType:'title', validators: ['requireds'],
            },    
            password: {  
                idelement: "password",  value:"", label: "Ingrese contraseña", pattern:"^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[$@#$!¡:.;{}+=^~|%*¿?&/-])[A-Za-z\\d$@#$!¡:.;{}+=^~|%*¿?&/-]\\S{6,50}$", 
                validators: ['required'], errorMessages:['Ingrese una contraseña válida'], isError:false, elementType:'password' ,finalRequiredLength: 50
            },
        }),
        [dejarEmpadronar, setDejarEmpadronar] = useState(false),        
        [base64ConstanciaParaHuella, setBase64ConstanciaParaHuella] = useState(''),
        [cveConstanciaParaHuella, setCVEConstanciaParaHuella] = useState(''),
        [modalConfirmation, setModalConfirmation] = useState(false);

    const datosExtranjeroRef = useRef(props.datosSolicitudExtranjero);
    const RechazarSolicitud=()=>{ 
        props.SOLICITUD_EMPADRONAMIENTO_SET_RECHAZAR_SOLICITUD_EN_EL_EXTRANJERO(true);
        props.STEP_RECHAZO_SOLICITUD_EXTRANJERO_SET_STEP(1);
    };
    const Cancelar = () => {
        let datosSolicitudGeneradoNancional = {datosSolicitudGeneradoNancional:{cui: '', usuario: ''}}
        dispatch(allActions.solicitudDatosGenerado(datosSolicitudGeneradoNancional))
        props.SOLICITUD_EMPADRONAMIENTO_SET_ID_SOLICITUD_GENERADO('')
        props.SOLICITUD_EMPADRONAMIENTO_SET_ES_RECHAZADO_O_EMPADRONADO(false)
        // props.actualizarTabla()
        props.handleClose()
        elements.password.value = ''
        setBase64ConstanciaParaHuella('')
        setCVEConstanciaParaHuella('')            
    }        

    const EmpadronarActualizarConfirmacion=async()=>{
        if(cveConstanciaParaHuella && !base64ConstanciaParaHuella ){
            return setModalConfirmation(true)                
        }
        if(cveConstanciaParaHuella && base64ConstanciaParaHuella){
            return ProcesarInscripcionUActualizacion(true)                
        }
        // setCVEConstanciaParaHuella('')
        ProcesarInscripcionUActualizacion(false)
    };
    const ProcesarInscripcionUActualizacion=async(constanciaParaHuella)=>{
        let allGood = true;
        allGood = functions.checkIsEmptyWhenRequiredElement(
            elements,
            setElements
        );        
        if(allGood){
            setLoadingMessage({loading: true, title:'Procesando solicitud ...'})
            let data = {
                idSolicitud:props.datosSolicitudExtranjero.idSolicitud,
                departamento:props.datosSolicitudExtranjero.departamentoResidencia?.id,
                municipio:props.datosSolicitudExtranjero.municipioResidencia?.id?.id,
                comunidad:props.datosSolicitudExtranjero.comunidadResidencia?.codigoComunidad,
                cenVotacion:props.datosSolicitudExtranjero.centroVotacion,
                profesion:props.datosSolicitudExtranjero.complementoSolicitudesEmpadronamiento?.profesionName?.id,
                direccion:props.datosSolicitudExtranjero.direccion,
                numeroCasa:props.datosSolicitudExtranjero.numeroCasa,
                numeroZona:props.datosSolicitudExtranjero.numeroZona,
                password:elements.password.value,
                base64ConstanciaParaHuella: base64ConstanciaParaHuella,
                codigoCVE: !constanciaParaHuella ? '' : cveConstanciaParaHuella,
                observaciones: elements.observaciones.value ? elements.observaciones.value.trim() : '',
            }
            if(props.datosSolicitudExtranjero.direccion === false) data.direccion = '';
            try{
                const response =  await ApiServices.verificarSolicitudDeEmpadronamiento.autorizar(data);
                if(response.error!==null){
                    showMessagePersonalizedPosition('warning','¡Advertencia!', response.error.message,'center')
                }else{
                    let datosSolicitudGeneradoNancional = {datosSolicitudGeneradoNancional:{cui: '', usuario: ''}}
                    dispatch(allActions.solicitudDatosGenerado(datosSolicitudGeneradoNancional))
                    // dispatch(allActions.idSolicitudDelegacionProcesado({open: true, idSolicitud: response.data.idSolicitud, base64: response.data.signedDocument}))
                    props.SOLICITUD_EMPADRONAMIENTO_SET_ID_SOLICITUD_GENERADO('')
                    setBase64ConstanciaParaHuella('')
                    setCVEConstanciaParaHuella('')
                    props.SOLICITUD_EMPADRONAMIENTO_SET_ES_RECHAZADO_O_EMPADRONADO(true)
                    props.SOLICITUD_EMPADRONAMIENTO_SET_EVENTO_RENAP(false)
                    props.SOLICITUD_EMPADRONAMIENTO_SET_ESTA_FALLECIDO(false)
                    props.SOLICITUD_EMPADRONAMIENTO_SET_ESTA_EMPADRONADO(false)
                    props.handleClose()
                    // props.actualizarTabla()
                    // props.ObtenerTotalDeSolicitudesPendientesDeRealizar()
                    showMessagePersonalizedPosition('success','¡BIEN!', 'Solicitud # '+props.datosSolicitudExtranjero.idSolicitud+' procesada correctamente.')
                }   
            }catch(exception){
                showMessagePersonalizedPosition('error', '¡Advertencia! ', "Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.", 'center')
            }               
        }
        setLoadingMessage({loading: false, title:''})
    };

    const EnviarSolicitud = async() =>{
        setModalConfirmation(false)                
        setCVEConstanciaParaHuella('')
        await ProcesarInscripcionUActualizacion(false)            
    }
    
    const DescargarConstanciaPDFParaHuella = async () => {
        setLoadingMessage({loading: true, title:'Descargando constancia para huella ...'})
        var datos = {idSolicitud: props.datosSolicitudExtranjero.idSolicitud}
        try{
            const response =  await ApiServices.constanciaEmpadronamiento.pdfDeInscripcionOActualizacion(datos);
            if(response.error!==null){
                showMessagePersonalizedPosition('warning','¡Advertencia!', response.error.message,'center')
            }else{
                showMessagePersonalizedPosition('success', '¡BIEN!','Constancia Descargada correctamente.', 'center')
                functions.downloadPDFFromStringBase64(response.data.constancia, "Constancia.pdf");   
                setCVEConstanciaParaHuella(response.data.codigoCVE)
            }   
        }catch(exception){
            if (exception.status===404) {
                showMessagePersonalizedPosition('error', '¡Advertencia!', "Falla del Sistema. Ponganse en contacto con el Administrador sí este mensaje persiste.", 'center')
            }
            else {
                showMessagePersonalizedPosition('error', '¡Advertencia! ', "Intente de nuevo. Ponganse en contacto con el Administrador sí este mensaje persiste.", 'center')
            }
        }
        setLoadingMessage({loading: false, title:''})
    }
    
    const uploadPDF = async (event) => {
        if(cveConstanciaParaHuella === ''){
            showMessagePersonalizedPosition('warning', '¡Advertencia!', 'Para realizar esta acción, deberá primero descargar la constancia PDF, para luego adjuntarlo nuevamente. Intente de nuevo.', 'center')
        }else{
            event.target.files=null
            const file_size = event.target.files[0];
            if(file_size !== undefined){
                var arr1 = file_size.type.split('/');
                if(arr1[1] === 'pdf'){
                    const base64 = await convertBase64(file_size);  
                    setBase64ConstanciaParaHuella(base64)
                    showMessagePersonalizedPosition('success','¡BIEN!', 'Archivo PDF adjuntado correctamente.', 'center')
                }else{
                    showMessagePersonalizedPosition('error','¡Advertencia!', 'Formato no permitido, Por favor subir archivo en formato .pdf Intente de nuevo', 'center')
                }
            }
        }
    }
    const convertBase64 = (file) => {
        if(file){
            return new Promise((resolve, reject) => {
                const fileReader = new FileReader();
                fileReader.readAsDataURL(file);
                fileReader.onload = () => { resolve(fileReader.result); };
                fileReader.onerror = (error) => { reject(error);    };
            });
        } 
    };   

    useEffect(() => {
        if(props.estaFallecido === true) {
            setDejarEmpadronar(true);
        }else {
            setDejarEmpadronar(false);
        } 
    }, [props.estaFallecido, props.eventoRENAP]);
    
    useEffect(() => {
        // console.log("props.citaEnProceso en GrabarSolicitudExtranjero:", props.citaEnProceso);
        // console.log("props.citaEnProcesoVacia en GrabarSolicitudExtranjero:", props.citaEnProcesoVacia);

    }, []);

    const closeModalConfirmation = () => {
        setModalConfirmation(false);
    }

    return (
        <div className={classes.root}>
            <DialogLoadingMessage open={loadingMessage.loading} title={loadingMessage.title}/>
            <ModalConfirmation
                actionAdd={EnviarSolicitud}
                open={modalConfirmation}
                closeModal={closeModalConfirmation}
                titleButton="PROCESAR SIN ADJUNTAR"
            >
                <Typography className={classes.title} >
                    {/* Hemos detectado que descargo la constancia en PDF, más no adjunto la constancia modificada con la huella del ciudadano. */}
                    Hemos detectado que descargo la constancia en PDF, por lo tanto, debe adjuntarla con la huella del ciudadano.
                    Sí no desea adjuntarlo, dar clic en el bóton "PROCESAR SIN ADJUNTAR".
                </Typography>
                <Typography className={classes.description} >
                    ¿Está seguro de continuar con el proceso sin adjuntar el documento PDF modificado?
                </Typography>
            </ModalConfirmation>            
            <div className={classes.colorComponente}>
                <Grid >
                    <Grid item xs={12} container direction="row" justify="center" alignItems="center"> 
                        <Typography component="span" variant="body1" color="textPrimary"> <strong>RESUMEN DE LA SOLICITUD NO. {props.datosCiudadanoTable.idSolicitud}</strong></Typography>
                    </Grid>
                    <Grid className={classes.marginText} item xs={12} > 
                        <ResumenSolicitudExtranjero open={props.open}/>
                    </Grid>
                </Grid><br/>
                <div className={classes.lineaDegradadaBottom}></div>
            </div> <br/>            

            <div className={classes.colorComponente}>
                <Grid container direction="row" justify="center" alignItems="center" >
                    <Grid className={classes.AlignTable} item xs={12} > 
                        <Form   elements= {elements} BotonCancelar={RechazarSolicitud} BotonCerrar={Cancelar} 
                            disabled={dejarEmpadronar} BotonProcesar={EmpadronarActualizarConfirmacion} 
                            BotonDescargarPDF={DescargarConstanciaPDFParaHuella} 
                        />
                        <div className={classes.label}>                                
                            <input multiple
                                name={'descargarConstanciaPDF'}
                                type={"file"}
                                accept={'.pdf'}
                                onChange={(e) => {uploadPDF(e) }}
                                className={classes.input}
                                id={'descargarConstanciaPDF'}
                            />
                            <label className={classes.imageUpload} htmlFor={'descargarConstanciaPDF'}>Seleccionar Constancia PDF </label>
                        </div>                        
                    </Grid>
                </Grid><br/>
                <div className={classes.lineaDegradadaBottom}></div>
            </div><br/>
        </div>
    );
}
export default connect(mapStateToProps, mapDispatchToProps)(GrabarSolicitudExtranjero);